import { Loader2, Inbox, AlertTriangle, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function Loader({ label = "Loading", fullscreen = false }) {
  return (
    <div
      data-testid="loading-state"
      className={`flex flex-col items-center justify-center gap-3 text-muted-foreground ${
        fullscreen ? "min-h-screen" : "py-20"
      }`}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-accent/10">
        <Loader2 className="h-5 w-5 animate-spin text-accent" />
      </div>
      <p className="text-sm font-medium">{label}…</p>
    </div>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, testid = "empty-state" }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-surface/50 py-16 px-6 text-center"
    >
      <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-border bg-elevated text-muted-foreground">
        <Icon className="h-5 w-5" />
      </span>
      <h3 className="font-display text-base font-semibold text-foreground">{title}</h3>
      {description && <p className="mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function ErrorState({ message = "Something went wrong.", onRetry, testid = "error-state" }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center justify-center rounded-2xl border border-destructive/30 bg-destructive/5 py-14 px-6 text-center"
    >
      <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-destructive/30 text-destructive">
        <AlertTriangle className="h-5 w-5" />
      </span>
      <p className="max-w-sm text-sm text-foreground">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" className="mt-5" onClick={onRetry} data-testid="retry-button">
          <RotateCw className="mr-2 h-3.5 w-3.5" /> Try again
        </Button>
      )}
    </div>
  );
}
